import { parseOptional, parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetAccountsResponse } from "@syla/shared/types/responses/GetAccountsResponse";
import axios from "axios";
import { parseSubscription } from "../plans/parseSubscription";

export async function getAccounts(): Promise<GetAccountsResponse> {
  const response =
    await axios.get<TransportType<GetAccountsResponse>>(`/accounts`);

  return deserialise(response.data);
}

function deserialise(
  data: TransportType<GetAccountsResponse>,
): GetAccountsResponse {
  return {
    accounts: Object.fromEntries(
      Object.entries(data.accounts).map(([accountId, account]) => [
        accountId,
        {
          ...account,
          subscriptions: account.subscriptions.map(parseSubscription),
          createdAt: parseOptional(account.createdAt, parseDate),
          updatedAt: parseOptional(account.updatedAt, parseDate),
        },
      ]),
    ),
  };
}
